import { gql } from '@apollo/client';

export const CREATE_PREP_TOOL_PURCHASE = gql`
  mutation CREATE_PREP_TOOL_PURCHASE(
    $prepTools: [PrepToolInput]!
    $discount: String
    $referrer: String
    $country: String
  ) {
    createPrepToolPurchase(prepTools: $prepTools, discount: $discount, referrer: $referrer, country: $country) {
      ... on PurchaseCreated {
        registrationId
      }
      ... on PurchaseCannotBeCreated {
        reason
      }
    }
  }
`;
